import React from 'react';
import ReactDOM from 'react-dom';
import { Initializer } from 'common/types/initializers';
import { Reconnect } from 'federation/Reconnect';

type ClientListImportModalSource =
  | 'next_best_action'
  | 'clients_list_button'
  | 'clients_list_empty_state'
  | 'direct';

export const ClientListImportModalInitializer = (props: {
  source: ClientListImportModalSource;
  onUseTemplate: () => void;
}): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="ClientListImportModal"
        props={{ onClose: destroy, onUseTemplate: props.onUseTemplate, source: props.source }}
      />,
      container,
    );
  };

  return { destroy, render };
};
